var map = {
	"./english/home/pc/role/video/1.wav": "d6Sp",
	"./english/home/pc/role/video/2.wav": "IgHy",
	"./english/home/pc/role/video/3.wav": "QtcX",
	"./english/home/pc/role/video/4.wav": "jsAf",
	"./english/home/pc/role/video/5.wav": "S+9t",
	"./traditional/home/pc/role/video/1.wav": "LQIG",
	"./traditional/home/pc/role/video/2.wav": "59+S",
	"./traditional/home/pc/role/video/3.wav": "0spi",
	"./traditional/home/pc/role/video/4.wav": "CYNy",
	"./traditional/home/pc/role/video/5.wav": "oKnR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6tqM";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.wav$
// module id = 6tqM
// module chunks = 0